import numeral from 'numeral'
import React from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  phaseChange,
  reroute,
  sendContract,
  storeDumpItForce,
  updateOrdine,
} from '../../../actions/Buy'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import Logo from '../../icons/Logo'
import BuyPricePromozione from '../dumb/BuyPricePromozione'
import { haGaranzia3Anni, prepara_valori_logistica } from '../utils'

class PreviewContratto extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.toTop = false
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 35 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }
    this.props.storeDumpItForce()
  }

  handleSubmit() {
    if (!this.props.fetching) {
      if (
        'token' in this.props.customer &&
        this.props.customer.token !== null &&
        this.props.customer.token.length > 0
      ) {
        if (
          !('proposta_contrattuale_sent' in this.props.ordine) ||
          this.props.ordine.proposta_contrattuale_sent === false
        ) {
          this.props
            .sendContract({
              method: 'POST',
              uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${this.props.ordine.id_ordine}/template/proposta_contrattuale_usato`,
              body: JSON.stringify({}),
              token: this.props.customer.token,
            })
            .then(() => {
              this.props.updateOrdine({
                proposta_contrattuale_sent: true,
              })
              this.props.phaseChange({
                last: this.props.ui.last > 35 ? this.props.ui.last : 35,
              })
              this.props.reroute('/bonifico')
            })
            .catch(() => null)
        } else {
          this.props.phaseChange({
            last: this.props.ui.last > 35 ? this.props.ui.last : 35,
          })
          this.props.reroute('/bonifico')
        }
      }
    }
  }

  render() {
    const { customer } = this.props
    const { ordine } = this.props
    const { product } = this.props
    numeral.language('it')
    const mesi = [
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre',
    ]
    const mesi_nr = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
    ]
    const data_immatricolazione = `${mesi_nr[product.mese - 1]}/${product.anno}`

    const today_date = new Date()
    const today = `${today_date.getDate()} ${
      mesi[today_date.getMonth()]
    } ${today_date.getFullYear()}`

    const nato_estero =
      'comune_nascita' in customer && customer.comune_nascita !== null
        ? customer.comune_nascita.split('|')[3].slice(0, -4)
        : ''
    const nato_italia =
      'comune_nascita' in customer && customer.comune_nascita !== null
        ? customer.comune_nascita.split('|')[3]
        : ''

    const mese_nascita = parseInt(customer.data_di_nascita.month) - 1

    const {
      prezzo_logistica_promozione,
      prezzo_logistica,
      is_free_price,
      centro_convenzionato_nome,
      number_or_text,
    } = prepara_valori_logistica(this.props.pricing.total, this.props.logistica)

    return (
      <div>
        <div className={'process__header hide-print'}>
          <h1 className={'process__title hide-print'}>Proposta contrattuale</h1>
          <p className={'process__intro hide-print'}>
            Puoi verificare la correttezza dei dati e proseguire per concludere
            il processo.
            <br />
            Ti abbiamo inviato la copia della proposta contrattuale per email,
            controlla la tua casella di posta!
          </p>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className={'user-informations'}>
          <div className={'container--small'}>
            <div className={'buttons_set top no-brd center hide-print'}>
              <a
                className={'btn btn-secondary only-desktop'}
                href="javascript:window.print()"
              >
                <span>Stampa documento</span>
              </a>
              <a
                className={`btn btn-primary${
                  this.props.fetching ? ' btn-disabled' : ''
                }`}
                data-cy="contract-submit"
                href="#"
                onClick={event => {
                  this.handleSubmit()
                  event.preventDefault()
                  event.stopPropagation()
                }}
              >
                <span>Prosegui</span>
              </a>
            </div>

            <div className={'paper_a4 contratto'}>
              <div className={'paper_a4_head'}>
                <div className={'paper_a4_head_wide'}>
                  <div className={'print_logo'}>
                    <Logo />
                  </div>
                </div>
              </div>
              <div className={'paper_a4_body long'}>
                <h1>Proposta contrattuale</h1>
                <div className={'intro'}>
                  <div className={'intro_content last'}>
                    Ordine n° {ordine.id_ordine}
                    <br />
                    Codice auto {product.id_auto}
                  </div>
                  <div className={'intro_data'}>{today}</div>
                </div>

                <p data-hj-suppress>
                  {/* eslint-disable-next-line */}
                  {customer.sesso == 'F'
                    ? 'La sottoscritta'
                    : 'Il sottoscritto'}{' '}
                  <span className={'replace capitalize'}>
                    {customer.nome} {customer.cognome}
                  </span>
                  , {customer.sesso === 'F' ? 'nata' : 'nato'}
                  {customer?.comune_nascita.split('|')[1] === 'EE'
                    ? ' in '
                    : ' a '}
                  {customer?.comune_nascita.split('|')[1] === 'EE' ? (
                    <strong>{nato_estero}</strong>
                  ) : (
                    <strong>{nato_italia} </strong>
                  )}
                  il{' '}
                  <span className={'replace capitalize'}>
                    {customer.data_di_nascita.day} {mesi[mese_nascita]}{' '}
                    {customer.data_di_nascita.year}{' '}
                  </span>
                  e residente in{' '}
                  <span className={'replace capitalize'}>
                    {customer.indirizzo_residenza}{' '}
                    {customer.numero_civico_residenza},{' '}
                    {'citta_residenza' in customer &&
                    customer.citta_residenza !== null
                      ? customer.citta_residenza.split('|')[3]
                      : ''}{' '}
                  </span>
                  di nazionalità{' '}
                  <span className={'replace'}>
                    {'cittadinanza' in customer &&
                    customer.cittadinanza !== null
                      ? customer.cittadinanza.split('|')[1]
                      : ''}
                  </span>
                  , Codice Fiscale{' '}
                  <span className={'replace uppercase'}>
                    {customer.codice_fiscale}
                  </span>
                  invia la presente proposta contrattuale a brumbrum S.p.A.,
                  Sede Legale via Benigno Crespi, 23 - 20159 Milano, P.Iva IT
                  09323210964 ai fini dell'acquisto del seguente veicolo:
                </p>
                <ul className={'print_car_details_list'}>
                  <li>
                    <span className={'replace'}>
                      {product.marca} {product.modello}
                    </span>
                    <span className={'small'}>Marca e Modello</span>
                  </li>
                  <li>
                    <span className={'replace'}>{product.telaio}</span>
                    <span className={'small'}>Telaio</span>
                  </li>
                  <li>
                    <span className={'replace'}>{data_immatricolazione}</span>
                    <span className={'small'}>Immatricolazione</span>
                  </li>
                  <li>
                    <span className={'replace'}>
                      {product.km0 === 'Si'
                        ? 'km 0'
                        : `${numeral(product.km).format('0,0')} km`}
                    </span>
                    <span className={'small'}>Chilometraggio</span>
                  </li>
                </ul>

                <p>Il prezzo totale comprende:</p>

                <div id={'preview_contratto_rows'}>
                  <div className={'f-table'}>
                    <div className={'row'}>
                      <div className={'five'}>
                        {product.marca} {product.modello}{' '}
                        {product.allestimento_breve}{' '}
                        {customer.agevolazione_iva_104 ? '(IVA 4%)' : null}
                      </div>

                      <div className={'five last'}>
                        {ordine.sconto ? (
                          <BuyPricePromozione
                            isFreePrice
                            numberOrText={'number'}
                            prezzoLogistica={numeral(
                              ordine.auto_prezzo_sellout
                            ).format('$ 0,0[.]00')}
                            prezzoLogisticaPromozione={numeral(
                              ordine.auto_prezzo_sellout - ordine.sconto
                            ).format('$ 0,0[.]00')}
                            promoLabel={'Sconto'}
                          />
                        ) : (
                          numeral(ordine.auto_prezzo_sellout).format(
                            '$ 0,0[.]00'
                          )
                        )}
                      </div>
                    </div>

                    <div className={'row'}>
                      <div className={'five'}>Passaggio di proprietà</div>

                      <div className={'five last'}>
                        {numeral(ordine.auto_costo_passaggio_proprieta).format(
                          '$ 0,0[.]00'
                        )}
                      </div>
                    </div>

                    {haGaranzia3Anni(this.props.garanzia) && (
                      <div className={'row'}>
                        <div className={'five'}>
                          3 anni di garanzia sui guasti e assistenza stradale
                        </div>

                        <div className={'five last'}>
                          <span className={'yellow'}>Inclusa</span>
                        </div>
                      </div>
                    )}

                    <div className={'row'}>
                      <div className={'five'}>
                        Lavaggio ed igienizzazione professionale
                      </div>

                      <div className={'five last'}>
                        <span className={'free-price giallo'}>Incluso</span>
                      </div>
                    </div>

                    {this.props.ordine.servizi_extra &&
                    this.props.ordine.servizi_extra.ordini_servizi
                      ? this.props.ordine.servizi_extra.ordini_servizi.map(
                          servizio_aggiuntivo => (
                            <div
                              className="row"
                              key={`vas-${servizio_aggiuntivo.id_servizio}`}
                            >
                              <div className="five">
                                {servizio_aggiuntivo.titolo || 'no title'}
                              </div>
                              <div className="five last">
                                <BuyPricePromozione
                                  isFreePrice
                                  numberOrText={'number'}
                                  prezzoLogistica={
                                    servizio_aggiuntivo.prezzo_listino
                                      ? numeral(
                                          servizio_aggiuntivo.prezzo_listino
                                        ).format('$ 0,0[.]00')
                                      : numeral(
                                          servizio_aggiuntivo.prezzo
                                        ).format('$ 0,0[.]00')
                                  }
                                  prezzoLogisticaPromozione={numeral(
                                    servizio_aggiuntivo.prezzo
                                  ).format('$ 0,0[.]00')}
                                />
                              </div>
                            </div>
                          )
                        )
                      : null}

                    <div className={'row'}>
                      <div className={'five'}>
                        Consegna presso{' '}
                        <span className="citta-scelta" data-hj-suppress>
                          {centro_convenzionato_nome}
                        </span>
                      </div>

                      <div className={'five last'}>
                        <BuyPricePromozione
                          isFreePrice={is_free_price}
                          numberOrText={number_or_text}
                          prezzoLogistica={prezzo_logistica}
                          prezzoLogisticaPromozione={
                            prezzo_logistica_promozione
                          }
                        />
                      </div>
                    </div>

                    <div className={'row foo'}>
                      {this.props.ordine.acconti ? (
                        <div className={'five'} style={{ paddingBottom: 0 }}>
                          <span>Totale ordine</span>
                        </div>
                      ) : null}

                      {this.props.ordine.acconti ? (
                        <div
                          className={'five last'}
                          style={{ paddingBottom: 0 }}
                        >
                          <span>
                            {numeral(this.props.ordine.totale).format(
                              '$ 0,0[.]00'
                            )}
                          </span>
                        </div>
                      ) : null}

                      {this.props.ordine.acconti ? (
                        <div
                          className={'five'}
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <span>Acconto pre-autorizzato</span>
                        </div>
                      ) : null}

                      {this.props.ordine.acconti ? (
                        <div
                          className={'five last'}
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                        >
                          <span>
                            {numeral(this.props.ordine.acconti).format(
                              '$ 0,0[.]00'
                            )}
                          </span>
                        </div>
                      ) : null}

                      <div className={'five'}>
                        <strong>
                          Totale {this.props.ordine.acconti ? 'dovuto' : null}{' '}
                          {this.props.product.regime_iva === 'Margine'
                            ? null
                            : '(IVA inclusa)'}
                        </strong>
                      </div>

                      <div className={'five last'}>
                        <strong>
                          {numeral(
                            this.props.ordine.totale - this.props.ordine.acconti
                          ).format('$ 0,0[.]00')}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                <p className={'small'}>
                  La presente proposta è regolata dalle Condizioni Generali di
                  Contratto (CGC), dai Termini di Utilizzo del Sito web
                  brumbrum.it, dalla Privacy Policy e da tutta la documentazione
                  concernente l’utilizzo del Sito stesso che devono intendersi
                  qui tutte richiamate come parte integrante e sostanziale del
                  presente atto.
                  <br />
                  L’accettazione, da parte di brumbrum S.p.A, della presente
                  proposta contrattuale è comunque condizionata{' '}
                  {customer.agevolazione_iva_104
                    ? " alla verifica della documentazione necessaria per l'agevolazione IVA, "
                    : null}
                  al buon esito della procedura d’acquisto e alla verifica del
                  buon fine del saldo del prezzo di acquisto tramite bonifico
                  bancario SEPA.
                  <br />
                  <br />
                </p>
              </div>

              <div className={'paper_a4_footer'}>
                <div className={'paper_a4_footer_right half'}>
                  <span className={'f-signature'}>
                    <span className={'the-name'}>L'acquirente</span>
                    <span className={'f-client'} data-hj-suppress>
                      <em>
                        {customer.nome} {customer.cognome}
                      </em>
                    </span>
                  </span>
                </div>
              </div>

              <div className={'paper_a4_pie'}>
                <div className="paper_a4_pie_info_mobile_row">
                  <div className={'paper_a4_pie_info'}>
                    <strong>
                      brumbrum S.p.A. a socio unico
                      <br />
                      <br />
                    </strong>
                    Società soggetta alla direzione e coordinamento di Aramis
                    Group S.A.
                  </div>
                </div>
                <div className="paper_a4_pie_info_mobile_row">
                  <div className={'paper_a4_pie_info'}>
                    <strong>Milano</strong>
                    <br />
                    Via B. Crespi, 23
                  </div>
                  <div className={'paper_a4_pie_info'}>
                    <strong>Numero REA</strong>
                    <br />
                    MI - 2083307
                  </div>
                </div>
                <div className="paper_a4_pie_info_mobile_row">
                  <div className={'paper_a4_pie_info'}>
                    <strong>Partita IVA</strong>
                    <br />
                    IT 09323210964
                  </div>
                  <div className={'paper_a4_pie_info last'}>
                    <strong>Capitale sociale</strong>
                    <br />
                    Euro 218.547,65 i.v.
                  </div>
                </div>
              </div>
            </div>

            <div className={'buttons_set bottom no-brd center hide-print'}>
              <a
                className={'btn btn-secondary only-desktop'}
                href="javascript:window.print()"
              >
                <span>Stampa documento</span>
              </a>
              <a
                className={`btn btn-primary${
                  this.props.fetching ? ' btn-disabled' : ''
                }`}
                href="#"
                onClick={event => {
                  this.handleSubmit()
                  event.preventDefault()
                  event.stopPropagation()
                }}
              >
                <span>Prosegui</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customer,
  product: state.product,
  ordine: state.ordine,
  pricing: state.pricing,
  fetching: state.ui.fetching,
  ui: state.ui,
  logistica: state.logistica,
  garanzia: state.garanzia,
})

export default connect(mapStateToProps, {
  phaseChange,
  storeDumpItForce,
  reroute,
  sendContract,
  updateOrdine,
})(PreviewContratto)
